module.exports = __webpack_public_path__ + "static/media/credit-card-duotone.4ac91253.svg";